<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-col style="display: flex;
  flex-flow: column;
  height: 100%; padding: 0">
        <b-row style=" flex-grow : 1; margin: 0px">
            <b-col id="sidebar_main" style="padding: 10px" class="sidebar2">
                <md-card style="background-color: white; max-height: 75vh; overflow-y: scroll;">
                    <md-card-content>
                        <b-row style="border-bottom:1px solid #b3b3b3; margin-bottom: 12px; margin-top: 16px">
                            <b-col>
                                <p style="color: #525252" class="font-lg"><b>Filter</b></p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Priorität:" label-for="select_priority">
                                    <b-form-select class="black" id="select_priority" plain v-on:input="changeFilter"
                                                   v-model="selections.priority" :options="selects.priority">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">-- Alle --
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Maßnahme:" label-for="select_task">
                                    <b-form-select class="black" id="select_task" plain v-on:input="changeFilter"
                                                   v-model="selections.task" :options="selects.task">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">-- Alle --
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Hilfsmittel:" label-for="select_tools">
                                    <b-form-select class="black" id="select_tools" plain v-on:input="changeFilter"
                                                   v-model="selections.tools" :options="selects.tools">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">-- Alle --
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Offen:" label-for="select_tools">
                                    <b-form-select class="black" id="select_tools" plain v-on:input="changeFilter"
                                                   v-model="selections.is_open" :options="selects.bools">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">-- Unerheblich --
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Beplant:" label-for="select_tools">
                                    <b-form-select class="black" id="select_tools" plain v-on:input="changeFilter"
                                                   v-model="selections.is_planned" :options="selects.bools">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">-- Unerheblich --
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="10">
                                <b-form-group label="Maßnahme fällig von:" label-for="select_task_von">
                                    <datetime
                                            v-model="task_start"
                                            input-class="form-control"
                                            input-style="color: black;"
                                            input-id="select_task_von"
                                            :phrases="datetimeConfigNext.phrases"
                                            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                                            v-on:input="changeFilter"
                                    ></datetime>
                                </b-form-group>
                            </b-col>
                            <b-col md="2" class="my-auto" style="margin-left: 0; padding-left: 0">
                                <clear-icon v-on:click="clearTaskVon" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: red; margin-top: 18px"></clear-icon>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="10">
                                <b-form-group label="Maßnahme fällig bis:" label-for="select_next_control_bis">
                                    <datetime
                                            v-model="task_end"
                                            input-class="form-control"
                                            input-style="color: black;"
                                            input-id="select_next_control_bis"
                                            :phrases="datetimeConfigLast.phrases"
                                            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                                            v-on:input="changeFilter"
                                    ></datetime>
                                </b-form-group>
                            </b-col>
                            <b-col md="2" class="my-auto" style="margin-left: 0; padding-left: 0">
                                <clear-icon v-on:click="clearTaskBis" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: red; margin-top: 18px"></clear-icon>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
            <b-col id="map_main" style="height: 100%; padding: 0px;  transition: margin-left .5s">
                <div style="position: absolute;
                width:100%;
                height:100%;
                top: 0; right: 0;
                bottom: 0; left: 0;"
                     id="map_container_1"
                     ref="map_container_1" v-on:toggle-sidebar="toggleSideBar"></div>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>

    import StylesControl from 'mapbox-gl-controls/lib/styles';
    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import MapboxGeocoder from 'mapbox-gl-geocoder';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
    import {Server_URL, URL_BAUMKONTROLLE} from "../../shared/utils";
    import ClearIcon from 'vue-material-design-icons/CloseCircle.vue';
    import AllTasksPopup from '../task/all_tasks_popup.vue';
    import Vue from 'vue';


    import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
    require('../../shared/free_draw');

    import {DateTime as LuxonDateTime} from 'luxon'



    class MyCustomControl {
        onAdd(map) {
            this.map = map;
            this.container = document.createElement('div');
            this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
            this.button = document.createElement('button');
            this.button.innerHTML = "☰ Filter";
            this.button.onclick = () => {
                let event = new Event('toggle-sidebar');
                this.button.dispatchEvent(event);
            };
            this.container.appendChild(this.button);
            return this.container;
        }

        onRemove() {
            this.container.parentNode.removeChild(this.container);
            this.map = undefined;
        }
    }

    const myCustomControl = new MyCustomControl();

    export default {
        components: {
            ClearIcon,
        },
        name: "all_tasks_map",
        mounted() {
            if (this.$route.query.customer_external !== undefined && this.$route.query.customer_external !== "") {
                this.isExternal = true;
                if (this.$route.query.permission !== undefined && this.$route.query.permission !== "") {
                    this.hasPermissionExternal = true;
                }
            }
            mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
            this.map = new mapboxgl.Map({
                container: 'map_container_1',
                style: 'mapbox://styles/mapbox/outdoors-v11',
                center: [10.244990, 50.943359],
                zoom: 6,
                minZoom: 5,
                maxPitch: 0,
            });
            this.marker = null;

            this.map.addControl(this.sidebarToggle, 'top-left');


            this.map.addControl(new StylesControl({
                styles: [
                    {
                        label: 'Normal',
                        styleName: 'Mapbox Streets',
                        styleUrl: 'mapbox://styles/mapbox/outdoors-v11',
                    }, {
                        label: 'Satellit',
                        styleName: 'Satellite',
                        styleUrl: 'mapbox://styles/mapbox/satellite-streets-v11',
                    },
                ],
                onChange: () => this.map.once("style.load", this.addLayers),
            }), 'top-left');

            this.map.addControl(new ZoomControl(), 'bottom-right');
            const languageControl = new LanguageControl({
                language: 'de',
            });
            this.map.addControl(languageControl);
            this.map.addControl(
                new MapboxGeocoder({
                    accessToken: mapboxgl.accessToken,
                    mapboxgl: mapboxgl,
                    placeholder: "Suchen"
                })
            );



            //this.map.on('click', this.onClick);
            this.map.on('load', this.mapLoad);
            this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/task/filters'
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
                visible: true,
                platform: {},
                map_types: {},
                //map: {},
                mapEvents: {},
                behavior: {},
                //marker: null,
                datetimeConfigNext: {phrases: {ok: 'Ok', cancel: 'Abbruch'}},
                datetimeConfigLast: {phrases: {ok: 'Ok', cancel: 'Abbruch'}},
                sidebarToggle: new class {
                    constructor(parent) {
                        this.parent = parent;
                    }

                    onAdd(map) {
                        this.map = map;
                        this.container = document.createElement('div');
                        this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
                        this.button = document.createElement('button');
                        this.button.innerHTML = "☰ Filter";
                        this.button.onclick = this.parent.toggleSideBar;
                        this.container.appendChild(this.button);
                        return this.container;
                    }

                    onRemove() {
                        this.container.parentNode.removeChild(this.container);
                        this.map = undefined;
                    }
                }(this),
                navopen: false,
                selected_layer: 'layer_vitality',
                //geojson: {},
                //current_layer_inside: null,
                //current_layer_unclustered: null,
                //current_layer_inside_text: null,
                //current_layer_unclustered_text: null,
                mapLoaded: false,
                requestLoaded: false,
                selects: {
                    task: [],
                    tools: [],
                    priority: [{text: "Hoch", value: 3}, {text: "Mäßig", value: 2}, {text: "Niedrig", value: 1}],
                    bools: [{text: "Ja", value: "true"}, {text: "Nein", value: "false"}],
                },
                selections: {
                    task: null,
                    tools: null,
                    priority: null,
                    is_open: null,
                    is_planned: null,
                },
                task_start: null,
                task_end: null,
                first_load: true,
                legend_options: {
                    layer_vitality: [],
                    layer_verkehrssicher: [],
                    layer_growing_state: [],
                    layer_security_expectation: [],
                    layer_condition: [],
                },
                isExternal: false,
                hasPermissionExternal: false,
            }
        },
        methods: {
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                if (response.status === 200) {
                    console.log(response);
                    this.selects.task = response.body.task;
                    this.selects.tools = response.body.tools;
                    this.$http.get(
                        Server_URL + '/baumkontrolle/all_tasks/map'
                    ).then(this.responseOkGeoJson, this.responseError)
                } else {
                    console.log(response);
                }
            },
            responseOkGeoJson(response) {
                this.hideLoader();
                if (response.status === 200) {
                    console.log("responseOkGeo")
                    this.geojson = response.body;
                    this.dataOutside = this.geojson;
                    console.log(this.dataOutside);

                    this.requestLoaded = true;
                    this.current_layer_unclustered = this.createLayer(false);
                    this.current_layer_clustered = this.createClusterLayer();
                    this.current_layer_unclustered_text = this.createLayerText(false);
                    this.current_layer_clustered_text = this.createClusterLayerText();

                    if (this.mapLoaded === true) {
                        this.addLayers();
                    }
                } else {
                    console.log(response);
                }
            },
            responseOkRefreshGeoJson(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.geojson = response.body;
                    setTimeout(() => {
                        let bounds = this.getBounds();
                        if (!bounds.isEmpty()) {
                            this.map.fitBounds(bounds, {padding: 120, duration: 1000});
                        }
                        this.onAreaUpdated();
                    });

                } else {
                    console.log(response);
                }
            },
            onAreaUpdated(e) {
                    this.dataOutside = this.geojson;
                    this.map.getSource('unclustered-source').setData(this.dataOutside);
            },
            createClusterLayer() {
                return {
                    id: 'clustered-point',
                    type: 'circle',
                    source: 'unclustered-source',
                    filter: ['has', 'point_count'],
                    paint: {
                        'circle-color': '#31aa2e',
                        'circle-radius': 30,
                        'circle-stroke-width': 2,
                        'circle-stroke-color': '#fff'
                    },
                }
            },
            createLayer(isInside) {
                return {
                    id: isInside ? 'inside-point' : 'normal-point',
                    type: 'circle',
                    source: isInside ? 'inside' : 'unclustered-source',
                    filter: ['!', ['has', 'point_count']],
                    paint: {
                        'circle-color': '#31aa2e',
                        'circle-radius': isInside ? 12 : 10,
                        'circle-stroke-width': isInside ? 1 : 1,
                        'circle-stroke-color': isInside ? '#4d4d4d' : '#fff'
                    },
                }
            },
            createLayerText(isInside) {
                return {
                    id: isInside ? 'inside-point-text' : 'normal-point-text',
                    type: 'symbol',
                    source: isInside ? 'inside' : 'unclustered-source',
                    filter: ['!', ['has', 'point_count']],
                    layout: {
                        'text-field': [
                            'number-format',
                            ['length', ['get', 'tasks']],
                            {}
                        ],
                        'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                        'text-size': 12
                    },
                    paint: {
                        'text-color': 'black',
                    },
                }
            },
            createClusterLayerText() {
                return {
                    id: 'cluster-point-text',
                    type: 'symbol',
                    source: 'unclustered-source',
                    filter: ['has', 'point_count'],
                    layout: {
                        'text-field': [
                            'number-format',
                            ['get', 'number_tasks'],
                            {}
                        ],
                        'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                        'text-size': 18
                    },
                    paint: {
                        'text-color': 'black',
                    },
                }
            },
            toggleSideBar() {
                if (!this.navopen) {
                    document.getElementById("sidebar_main").style.width = "250px";
                    document.getElementById("sidebar_main").style.visibility = "visible";
                } else {
                    document.getElementById("sidebar_main").style.width = "0px";
                    document.getElementById("sidebar_main").style.visibility = "hidden";
                }
                this.navopen = !this.navopen;
            },
            mapLoad() {
                console.log("mapLoad")
                this.mapLoaded = true;
                if (this.requestLoaded === true) {
                    this.addLayers();
                }
                this.map.on('mouseenter', 'normal-point', () => {
                    this.map.getCanvas().style.cursor = 'pointer';
                });
                this.map.on('mouseleave', 'normal-point', () => {
                    this.map.getCanvas().style.cursor = '';
                });
                this.map.on('click', 'normal-point', this.onMarkerClicked);
                this.map.on('mouseenter', 'clustered-point', () => {
                    this.map.getCanvas().style.cursor = 'pointer';
                });
                this.map.on('mouseleave', 'clustered-point', () => {
                    this.map.getCanvas().style.cursor = '';
                });
                this.map.on('click', 'clustered-point', this.onClusterClicked);
            },
            onClusterClicked(e) {
                const features = this.map.queryRenderedFeatures(e.point, {
                    layers: ['clustered-point']
                });
                const clusterId = features[0].properties.cluster_id;
                this.map.getSource('unclustered-source').getClusterExpansionZoom(
                    clusterId,
                    (err, zoom) => {
                        if (err) return;

                        this.map.easeTo({
                            center: features[0].geometry.coordinates,
                            zoom: zoom
                        });
                    }
                );
            },
            addLayers() {
                console.log("add layers");
                this.map.addSource('unclustered-source', {
                    type: 'geojson',
                    data: this.dataOutside,
                    cluster: true,
                    clusterMaxZoom: 12,
                    clusterRadius: 50,
                    clusterProperties: {
                        'number_tasks': ['+', ['length', ['get', 'tasks']]]
                    }
                });
                this.map.resize();
                this.addCurrentLayers();
                if (this.first_load) {
                    this.first_load = false;
                    setTimeout(() => {
                        let bounds = this.getBounds();
                        if (!bounds.isEmpty()) {
                            this.map.fitBounds(bounds, {padding: 120, duration: 1000});
                        }
                    });
                }
            },
            addCurrentLayers() {
                this.map.addLayer(this.current_layer_unclustered);
                this.map.addLayer(this.current_layer_clustered);
                this.map.addLayer(this.current_layer_unclustered_text);
                this.map.addLayer(this.current_layer_clustered_text);
            },
            changeFilter() {
                if (!this.mapLoaded) {
                    return;
                }

                let queryString = "?main=true";

                for (let filter in this.selections) {
                    if (this.selections[filter] !== null) {
                        queryString += "&"+filter+"="+encodeURIComponent(this.selections[filter]);
                    }
                }
                if (this.task_start !== null && this.task_start !== "") {
                    queryString += "&"+'finished_till_start'+"="+this.task_start;
                }
                if (this.task_end !== null && this.task_end !== "") {
                    queryString += "&"+'finished_till_end'+"="+this.task_end;
                }

                this.$http.get(
                    Server_URL + '/baumkontrolle/all_tasks/map'+queryString
                ).then(this.responseOkRefreshGeoJson, this.responseError)
            },
            getBounds() {
                let bounds = new (mapboxgl.LngLatBounds);
                this.geojson.features.forEach(el => {
                    bounds.extend(el.geometry.coordinates)
                });
                return bounds;
            },
            onSidebarToggle() {
                if (this.mapLoaded) {
                    this.map.resize();
                }
            },
            clearTaskVon() {
                this.task_start = null;
                this.changeFilter();
            },
            clearTaskBis() {
                this.task_end = null;
                this.changeFilter();
            },
            onMarkerClicked(e) {
                let coordinates = e.features[0].geometry.coordinates.slice();
                let props = e.features[0].properties;
                let ComponentClass = Vue.extend(AllTasksPopup);
                let instance = new ComponentClass({
                    propsData: { tableData: JSON.parse(e.features[0].properties.tasks) }
                });
                instance.$mount();
                instance.$on('task-clicked', (item) => {
                    this.openTask(item);
                });
                new mapboxgl.Popup()
                    .setLngLat(coordinates).setDOMContent(instance.$el).addTo(this.map);
            },
            openTask(item) {
                let newRoute = "tasks/task/"+item.id;
                if (this.isExternal) {
                    newRoute += "?customer_external=" + this.$route.query.customer_external + "&external_key=" + this.$route.query.external_key;
                    if (this.hasPermissionExternal) {
                        newRoute += "&permission=" + this.$route.query.permission
                    }
                }

              window.open(URL_BAUMKONTROLLE + newRoute, '_blank');

                //this.$router.push(newRoute);
            },
        },

    }
</script>

<style>
    .black {
        color: black;
    }
    .legend {
        box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        border-radius: 4px;
    }

    .sidebar2 {
        visibility: hidden;
        width: 0;
        position: absolute;
        z-index: 1 !important;
        overflow-x: hidden;
        -webkit-transition: 0.5s;
        transition: 0.5s;
        -moz-transition: 0.5s;
        padding: 0;
        top: 100px;
        -webkit-transition-property: width, visibility;
        transition-property: width, visibility;
        -moz-transition-property: width, visibility;
        -webkit-transition-timing-function: ease;
        transition-timing-function: ease;
        -moz-transition-timing-function: ease;
    }

    .mapboxgl-ctrl-top-left {
        display: flex;
        display: flex;
        display: -moz-flex;
        display: -webkit-flex;
        display: -o-flex;
    }

    .mapboxgl-ctrl-top-left .mapboxgl-ctrl {
        display: flex;
        display: flex;
        display: -moz-flex;
        display: -webkit-flex;
        display: -o-flex;
    }
    .mapboxgl-ctrl-top-left .mapboxgl-ctrl-group button+button {
        border-left: 1px solid #ddd;
        border-top: none;
    }

    .my-custom-control {
        color: #f00;
        background: #000;
        padding: 8px;
        border-radius: 4px;
        margin: 8px;
    }
    .mapboxgl-popup {
        max-width: 800px !important;
    }
    .mapboxgl-popup-close-button {
        font-size: 20px;
    }
</style>

<style scoped>

    .hoverable-icon:hover {
        cursor: pointer;
    }

</style>
